export const BASE_API_DEV_URL = 'https://galaxy.mycareerconnect.org'
export const BASE_API_PROD_URL = 'https://galaxy.mycareerconnect.org'
export const WEB_SOCKET_URL = 'wss://heckerbelladev.online/ws'
